/* SonaSleep theme JS — cart AJAX, cart drawer, reveal animations, countdown timers. */
(function () {
  'use strict';

  /* ---------- Scroll reveal (replaces framer-motion whileInView) ---------- */
  function initScrollReveal() {
    var els = document.querySelectorAll('.scroll-reveal');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '-50px' });
    els.forEach(function (el) { observer.observe(el); });
  }

  /* ---------- Countdown-to-midnight (announcement bar + bundle upsell timers) ---------- */
  function tickCountdownToMidnight() {
    var els = document.querySelectorAll('[data-countdown-to-midnight]');
    if (!els.length) return;
    var now = new Date();
    var end = new Date();
    end.setHours(23, 59, 59, 999);
    var diff = Math.max(0, end - now);
    var h = String(Math.floor(diff / 3600000)).padStart(2, '0');
    var m = String(Math.floor((diff % 3600000) / 60000)).padStart(2, '0');
    var s = String(Math.floor((diff % 60000) / 1000)).padStart(2, '0');
    els.forEach(function (el) { el.textContent = h + ':' + m + ':' + s; });
  }

  /* ---------- 10-minute bundle-offer countdown (resets each time cart opens) ---------- */
  var upsellInterval = null;
  function startUpsellCountdown() {
    var els = document.querySelectorAll('[data-upsell-countdown]');
    if (!els.length) return;
    var seconds = 10 * 60;
    clearInterval(upsellInterval);
    function render() {
      var m = String(Math.floor(seconds / 60)).padStart(2, '0');
      var s = String(seconds % 60).padStart(2, '0');
      els.forEach(function (el) { el.textContent = m + ':' + s; });
    }
    render();
    upsellInterval = setInterval(function () {
      seconds = Math.max(0, seconds - 1);
      render();
      if (seconds === 0) clearInterval(upsellInterval);
    }, 1000);
  }

  /* ---------- 10-minute cart reservation timer ---------- */
  var reservationInterval = null;
  function startReservationTimer() {
    var el = document.querySelector('[data-reservation-timer]');
    if (!el) return;
    var seconds = 10 * 60;
    clearInterval(reservationInterval);
    function render() {
      var expired = seconds <= 0;
      var m = String(Math.floor(seconds / 60)).padStart(2, '0');
      var s = String(seconds % 60).padStart(2, '0');
      el.classList.toggle('bg-destructive/8', expired);
      el.classList.toggle('border-destructive/20', expired);
      el.classList.toggle('bg-primary/8', !expired);
      el.classList.toggle('border-primary/20', !expired);
      el.innerHTML = expired
        ? '<span class="font-semibold text-destructive/90">Reservation expired — checkout now.</span>'
        : 'Reserved for <span class="font-semibold tabular-nums text-primary">' + m + ':' + s + '</span> — secure today\'s offer.';
    }
    render();
    reservationInterval = setInterval(function () {
      seconds = Math.max(0, seconds - 1);
      render();
      if (seconds === 0) clearInterval(reservationInterval);
    }, 1000);
  }

  /* ============================================================
     Cart AJAX — thin wrapper over Shopify's native cart endpoints.
     Bundle pricing is handled entirely by Shopify's own automatic
     discounts (configured in Shopify Admin > Discounts), so this
     layer only ever adds real variants at real prices/quantities.
     ============================================================ */
  var Cart = {
    get: function () {
      return fetch('/cart.js').then(function (r) { return r.json(); });
    },
    add: function (items) {
      // items: [{ id: <variant id>, quantity: <n>, properties: {...} }]
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items }),
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Could not add to cart'); });
        return r.json();
      });
    },
    update: function (updates) {
      // updates: { <variant id>: <absolute quantity> }
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates }),
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Could not update cart'); });
        return r.json();
      });
    },
    changeLine: function (line, quantity) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity }),
      }).then(function (r) { return r.json(); });
    },
    changeById: function (id, quantity) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: id, quantity: quantity }),
      }).then(function (r) { return r.json(); });
    },
    updateDiscount: function (code) {
      // Shopify applies a manual discount code via the cart's discount attribute at checkout,
      // not the cart endpoint itself — we forward it as a URL param on the checkout redirect.
      return Promise.resolve(code);
    },
  };
  window.SonaSleepCart = Cart;

  function renderCartCount(cart) {
    var badge = document.querySelector('[data-cart-count]');
    if (!badge) return;
    badge.textContent = cart.item_count;
    badge.classList.toggle('hidden', cart.item_count === 0);
    badge.classList.toggle('flex', cart.item_count > 0);
  }

  function openCartDrawer() {
    var drawer = document.getElementById('cart-drawer');
    var overlay = document.getElementById('cart-drawer-overlay');
    if (!drawer || !overlay) return;
    overlay.classList.remove('hidden');
    drawer.classList.remove('translate-x-full');
    document.body.style.overflow = 'hidden';
    startReservationTimer();
    startUpsellCountdown();
    refreshCartDrawer();
  }

  function closeCartDrawer() {
    var drawer = document.getElementById('cart-drawer');
    var overlay = document.getElementById('cart-drawer-overlay');
    if (!drawer || !overlay) return;
    overlay.classList.add('hidden');
    drawer.classList.add('translate-x-full');
    document.body.style.overflow = '';
    clearInterval(reservationInterval);
    clearInterval(upsellInterval);
  }
  window.SonaSleepCloseCartDrawer = closeCartDrawer;

  function refreshCartDrawer() {
    Cart.get().then(function (cart) {
      var event = new CustomEvent('cart:updated', { detail: cart });
      document.dispatchEvent(event);
    });
  }

  /* ---------- Add-to-cart button state ---------- */
  /* A bundle click used to fire /cart/add.js, then /cart.js, then
     /cart/update.js in series: three round trips before the drawer opened.
     One /cart/add.js carrying every line does the same work in one. */
  function startAdding(button) {
    if (!button) return;
    button._labelBefore = button.innerHTML;
    button.setAttribute('data-adding', '1');
    button.setAttribute('aria-busy', 'true');
    button.disabled = true;
    button.innerHTML = '<span>Adding\u2026</span>';
  }

  function stopAdding(button) {
    if (!button) return;
    if (typeof button._labelBefore === 'string') button.innerHTML = button._labelBefore;
    delete button._labelBefore;
    button.removeAttribute('data-adding');
    button.removeAttribute('aria-busy');
    button.disabled = false;
    if (window.lucide) window.lucide.createIcons();
  }

  /* Errors land under the button that was clicked rather than in an alert(),
     which on mobile hides the cart behind a system dialog. */
  function showAddError(button, message) {
    if (!button || !button.parentNode) return;
    var el = button.parentNode.querySelector('[data-cart-error]');
    if (!el) {
      el = document.createElement('p');
      el.setAttribute('data-cart-error', '');
      el.setAttribute('role', 'alert');
      el.className = 'mt-2 text-xs text-center text-destructive';
      button.parentNode.insertBefore(el, button.nextSibling);
    }
    el.textContent = message;
    el.classList.remove('hidden');
  }

  function clearAddError(button) {
    if (!button || !button.parentNode) return;
    var el = button.parentNode.querySelector('[data-cart-error]');
    if (el) el.classList.add('hidden');
  }

  function addToCartAndOpen(items, button) {
    if (!items || !items.length) return;
    if (button && button.getAttribute('data-adding') === '1') return; // second tap while the first is in flight
    clearAddError(button);
    startAdding(button);
    Cart.add(items)
      .then(function () {
        refreshCartDrawer();
        openCartDrawer();
      })
      .catch(function (err) {
        console.error('[cart] add failed:', err.message);
        showAddError(button, err.message || 'Could not add to cart. Please try again.');
      })
      .finally(function () {
        stopAdding(button);
      });
  }
  window.SonaSleepAddToCart = addToCartAndOpen;

  /* ---------- Delivery estimate (visitor's own clock, today + 8-10 days) ---------- */
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  function renderDeliveryEstimate() {
    var els = document.querySelectorAll('[data-delivery-estimate]');
    if (!els.length) return;
    var now = new Date();
    var from = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 8);
    var to = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 10);
    var text = from.getMonth() === to.getMonth()
      ? MONTHS[from.getMonth()] + ' ' + from.getDate() + '\u2013' + to.getDate()
      : MONTHS[from.getMonth()] + ' ' + from.getDate() + ' \u2013 ' + MONTHS[to.getMonth()] + ' ' + to.getDate();
    els.forEach(function (el) { el.textContent = text; });
  }

  function goToCheckout() {
    var code = window.SonaSleepCheckoutDiscount;
    window.location.href = code ? '/checkout?discount=' + encodeURIComponent(code) : '/checkout';
  }
  window.SonaSleepCheckout = goToCheckout;

  document.addEventListener('DOMContentLoaded', function () {
    initScrollReveal();
    tickCountdownToMidnight();
    setInterval(tickCountdownToMidnight, 1000);

    if (window.lucide) window.lucide.createIcons();

    var cartToggle = document.querySelector('[data-cart-toggle]');
    if (cartToggle) cartToggle.addEventListener('click', openCartDrawer);

    var closeButtons = document.querySelectorAll('[data-cart-close]');
    closeButtons.forEach(function (btn) { btn.addEventListener('click', closeCartDrawer); });

    var overlay = document.getElementById('cart-drawer-overlay');
    if (overlay) overlay.addEventListener('click', closeCartDrawer);

    document.addEventListener('cart:updated', function (e) { renderCartCount(e.detail); });

    renderDeliveryEstimate();
    refreshCartDrawer();
  });

  /* Back from checkout restores the page from the bfcache with the DOM exactly
     as it was left, so the drawer's Checkout button stayed disabled on
     "Processing...". Put it back, and release any Add button caught mid-flight. */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted && !document.querySelector('[data-cart-checkout][disabled]')) return;
    var checkoutBtn = document.querySelector('[data-cart-checkout]');
    if (checkoutBtn) {
      checkoutBtn.disabled = false;
      checkoutBtn.removeAttribute('disabled');
    }
    var checkoutLabel = document.querySelector('[data-checkout-label]');
    if (checkoutLabel) checkoutLabel.textContent = 'Checkout';
    document.querySelectorAll('[data-adding="1"]').forEach(stopAdding);
    renderDeliveryEstimate();
    refreshCartDrawer();
  });
})();
